"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentsSymbol = void 0;
const thunderbolt_ioc_1 = require("@wix/thunderbolt-ioc");
exports.ExperimentsSymbol = (0, thunderbolt_ioc_1.createIdentifier)(Symbol('ExperimentsSymbol'));
//# sourceMappingURL=experiments.js.map